/**
 * @param {Object} props
 * @param {string | undefined} [props.className]
 * @returns {React.ReactElement} The rendered component
 */
const BackToTopIconFmc = ({ className }) => (
  <svg
    className={className}
    version="1.1"
    width="25px"
    height="25px"
    viewBox="0 0 50 59"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="FRE-051_XL_backtotop"
      transform="translate(-1331.000000, -581.000000)"
    >
      <g
        id="icon-FRE-051-backtotop-Copy-2"
        transform="translate(1331.000000, 581.000000)"
      >
        <g
          id="Group-13"
          transform="translate(25.000000, 29.500000) rotate(90.000000) translate(-25.000000, -29.500000) translate(-4.500000, 4.500000)"
        >
          <rect
            id="Rectangle"
            x="5.5"
            y="-3.5"
            transform="matrix(2.535182e-06 1 -1 2.535182e-06 54.4997 -4.5001)"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#FFFFFF"
            fillOpacity="0.9"
            stroke="#0033A0"
            strokeWidth="2"
            width="48"
            height="57"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#0033A0"
            d="M44.6,31.8c0.2,0.2,0.7,0.2,0.9,0s0.2-0.7,0-0.9l-5.3-5.3C40.1,25.4,40,25.2,40,25
					s0.1-0.4,0.2-0.6l5.3-5.3c0.2-0.2,0.2-0.7,0-0.9C45.3,18.1,45.2,18,45,18s-0.3,0.1-0.4,0.2l-6.4,6.4c-0.2,0.2-0.2,0.7,0,0.9
					L44.6,31.8z"
          />
        </g>
        <path
          fill="#0033A0"
          d="M11.4,21.7v-2.1h9.4v2.1h-3.4V31h-2.5v-9.3H11.4z"
        />
        <path
          fill="#0033A0"
          d="M20.1,25.1c0.2-0.5,0.5-1,0.9-1.4s0.8-0.7,1.3-0.9c0.5-0.2,1.1-0.3,1.8-0.3s1.2,0.1,1.8,0.3
					c0.5,0.2,1,0.5,1.4,0.9s0.7,0.8,0.9,1.4c0.2,0.5,0.3,1.1,0.3,1.8s-0.1,1.3-0.3,1.8c-0.2,0.5-0.5,1-0.9,1.4s-0.8,0.7-1.4,0.9
					c-0.5,0.2-1.1,0.3-1.8,0.3s-1.2-0.1-1.8-0.3c-0.5-0.2-1-0.5-1.3-0.9s-0.7-0.8-0.9-1.4c-0.2-0.5-0.3-1.1-0.3-1.8
					S19.9,25.6,20.1,25.1z M22.2,27.8c0.1,0.3,0.2,0.6,0.3,0.8c0.2,0.2,0.4,0.5,0.6,0.6s0.6,0.2,1,0.2c0.4,0,0.7-0.1,1-0.2
					c0.3-0.1,0.5-0.3,0.6-0.6c0.2-0.3,0.3-0.5,0.3-0.8c0.1-0.3,0.1-0.6,0.1-1s0-0.7-0.1-1c-0.1-0.3-0.2-0.6-0.3-0.8
					c-0.2-0.2-0.4-0.4-0.6-0.6c-0.3-0.2-0.6-0.2-1-0.2c-0.4,0-0.7,0.1-1,0.2s-0.5,0.4-0.6,0.6c-0.2,0.2-0.3,0.5-0.3,0.8
					c-0.1,0.3-0.1,0.6-0.1,1S22.1,27.5,22.2,27.8z"
        />
        <path
          fill="#0033A0"
          d="M32,22.7v1.1h0c0.3-0.4,0.6-0.8,1.1-1c0.4-0.2,0.9-0.3,1.4-0.3c0.7,0,1.2,0.1,1.7,0.4
					c0.5,0.2,0.9,0.6,1.2,1c0.3,0.4,0.5,0.9,0.7,1.4c0.1,0.5,0.2,1.1,0.2,1.7c0,0.6-0.1,1.1-0.2,1.6c-0.1,0.5-0.4,1-0.7,1.4
					c-0.3,0.4-0.7,0.7-1.1,0.9c-0.5,0.2-1,0.4-1.6,0.4c-0.5,0-1-0.1-1.4-0.3c-0.4-0.2-0.8-0.5-1.1-0.9h0v3.9h-2.3V22.7H32z M35,29.3
					c0.3-0.1,0.5-0.3,0.6-0.6c0.2-0.2,0.3-0.5,0.3-0.8c0.1-0.3,0.1-0.6,0.1-1c0-0.3,0-0.7-0.1-1s-0.2-0.6-0.3-0.9
					c-0.2-0.2-0.4-0.5-0.6-0.6c-0.2-0.2-0.6-0.2-0.9-0.2c-0.4,0-0.7,0.1-0.9,0.2c-0.3,0.2-0.5,0.4-0.6,0.6c-0.2,0.2-0.3,0.5-0.3,0.8
					c-0.1,0.3-0.1,0.7-0.1,1c0,0.3,0,0.7,0.1,1c0.1,0.3,0.2,0.6,0.3,0.8c0.2,0.2,0.4,0.4,0.6,0.6c0.3,0.1,0.6,0.2,0.9,0.2
					C34.4,29.5,34.7,29.4,35,29.3z"
        />
      </g>
    </g>
  </svg>
);

export default BackToTopIconFmc;
